module.exports = "<app-help-heading></app-help-heading>\n<app-footer></app-footer>"